import { render, staticRenderFns } from "./Item4.vue?vue&type=template&id=cc50f6e8&scoped=true&"
import script from "./Item4.vue?vue&type=script&lang=js&"
export * from "./Item4.vue?vue&type=script&lang=js&"
import style0 from "./Item4.vue?vue&type=style&index=0&id=cc50f6e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc50f6e8",
  null
  
)

export default component.exports